import { post } from "../hooks/useHttp";

export const addPhoneNo = (data: any) => {
    return post(`/add-phone-number`, data);
}